import React from 'react'
import {gql} from 'apollo-boost'
import {graphql, Query} from 'react-apollo'

export const withSubscription = (WrappedComponent, schema, dataStructure, uniqueKey = 'id', variables = []) => {

    const vars = variables.map(({key, value}) => `${key}: "${value}"`)
    const gqlVars = (variables.length) ? `(${vars.join(',')})` : ''

    const queries = {
        read: gql`{${schema}${gqlVars} {${dataStructure}}}`,
        upsert: gql`subscription{${schema}Upserted${gqlVars} {${dataStructure}}}`,
        //update:
    }

    return graphql(queries.read, {
        name: 'data',
        props: props => {
            return {
                ...props,
                subscribeToCreate: () => {
                    return props.data.subscribeToMore(
                        {
                            document: queries.upsert,
                            updateQuery: (prev, {subscriptionData}) => {

                                if(!subscriptionData.data){
                                    return prev
                                }

                                console.log(subscriptionData)
                                console.log('prev', prev)

                                let data = {}

                                //does the record already exist using the uniqueKey
                                const existingRecordIndex = prev[schema].findIndex(data => data[uniqueKey] === subscriptionData.data[`${schema}Upserted`][uniqueKey])
                                //const existingRecordIndex = prev[schema].findIndex(data => eval(`data.${uniqueKey}`) === eval(`subscriptionData.data.${schema}Upserted.${uniqueKey}`))

                                if(existingRecordIndex !== -1){
                                    data[schema] = [
                                        ...prev[schema].slice(0,existingRecordIndex),
                                        {...subscriptionData.data[`${schema}Upserted`]},
                                        ...prev[schema].slice(existingRecordIndex+1)
                                    ]
                                }
                                else{
                                    data[schema] = [...prev[schema], subscriptionData.data[`${schema}Upserted`]]
                                }

                                console.log('final data', data)

                                return data
                            }
                        }
                    )

                }
            }
        }
    })(class extends React.Component {

        constructor(props){
            super(props)
        }

        componentDidMount(){
            this.props.subscribeToCreate()
        }

        render(){
            return <WrappedComponent {...this.props}/>
        }
    })
}



/*export const withSubscription = (WrappedComponent, schema, dataStructure) => {

    class SubscriptionWrapper extends React.Component{
        constructor(props){
            super(props)
        }

        componentDidMount(){
            this.props.subscribeToCreate()
        }

        render(){
            return this.props.children
        }
    }

    const queries = {
        read: gql`{${schema} {${dataStructure}}}`,
        create: gql`subscription{${schema}Created {${dataStructure}}}`,
        //update:
    }

    return (
        () => (
            <Query query={queries.read}>
                {(result) => {
                    return (
                        <SubscriptionWrapper
                            subscribeToCreate={() => {
                                return result.subscribeToMore(
                                    {
                                        document: queries.create,
                                        updateQuery: (prev, {subscriptionData}) => {

                                            if(!subscriptionData.data){
                                                return prev
                                            }

                                            let data = {}
                                            data[schema] = [...prev[schema], subscriptionData.data[`${schema}Created`]]
                                            return data
                                        }
                                    }
                                )
                            }}
                            >

                            <WrappedComponent
                                {...result}
                            />
                        </SubscriptionWrapper>
                    )
                }}
            </Query>

        )
    )


}*/

